import React, { FC, useEffect, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Helmet } from "react-helmet-async";
import UserForm from "components/Forms/UserForm";
import { useNavigate, useParams } from "react-router-dom";
import services from "utils/services";
import { Link } from "react-router-dom";
import { string, object } from "yup";
import dayjs from "dayjs";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { TrashIcon } from "@heroicons/react/24/solid";

export interface UserEditProps {
	className?: string;
}

const UserEdit: FC<UserEditProps> = ({ className = "" }) => {
	const [user, setUser] = useState<any>({});
	const [isEdit, setIsEdit] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [errors, setErrors] = useState<any>({});

	const [selected, setSelected] = useState("Informations");
	const [documentList, setDocumentList] = useState([]);
	const [documentLoaded, setDocumentLoaded] = useState(false);
	const auth = useSelector((state: any) => state.auth);

	const navigate = useNavigate();

	const getUserSchema = () => {
		return object({
			firstName: string().required(""),
			lastName: string().required(""),
			username: string().required(""),
			// password: user._id ? string().notRequired() : string().required(""),
			// email: string().required("").email("Email invalide"),
			// role: mixed().oneOf(["ADMIN", "ASSISTANT", "MANAGER"], "").required(""),
		});
	};

	const { userId } = useParams();
	useEffect(() => {
		if (userId) {
			services.getOneUser(
				userId,
				(success) => {
					setUser({
						...success.user,
						entryDate: success.user.entryDate
							? dayjs(success.user.entryDate).format("YYYY-MM-DD")
							: "",
						exitDate: success.user.exitDate
							? dayjs(success.user.exitDate).format("YYYY-MM-DD")
							: "",
					});

					setIsEdit(true);
				},
				(error) => {}
			);
		}
	}, [userId]);

	const getDocuments = () => {
		services.getDocuments(
			{ employee: userId },
			(success) => {
				setDocumentList(success.documents);
				setDocumentLoaded(true);
			},
			(error) => {}
		);
	};

	useEffect(() => {
		if (selected == "Bulletins" && !documentLoaded) getDocuments();
	}, [selected]);

	const checkFields = () => {
		let fieldErrors: any = {};
		try {
			getUserSchema().validateSync(user, { abortEarly: false });
			setErrors({});
			return true;
		} catch (err: any) {
			console.log(err);
			err.inner?.forEach((oneErr: { path: string; message: string }) => {
				fieldErrors[oneErr.path] = oneErr.message;
			});
			setErrors(fieldErrors);
			return false;
		}
	};

	const saveUser = () => {
		const isValid = checkFields();
		if (isValid) {
			setLoading(true);
			services.saveUser(
				user,
				(success) => {
					navigate(-1);
					setLoading(false);
				},
				(error) => {
					setLoading(false);

					if (error.response.status == 422) {
						// errors.email = error.response.data.message;
					} else {
						// errors.global = "Une erreur est survenue";
					}

					// setErrors({ ...errors });
					console.log(error);
				}
			);
		}
	};

	const download = async (doc: any) => {
		services.downloadDocument(
			{ id: doc._id },
			async (response, headers) => {
				// Récupérer le nom du fichier depuis les headers
				// let filename = `BULLETIN_${user.lastName}_${doc.documentYear}-${(
				// 	doc.documentMonth + ""
				// ).padStart(2, "0")}`;

				const contentDisposition = headers["content-disposition"];
				let filename = "document.pdf";

				if (contentDisposition) {
					const match = contentDisposition.match(
						/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
					);
					if (match && match[1]) {
						filename = match[1].replace(/['"]/g, "");
					}
				}

				// Créer un lien de téléchargement// Vérifier que response.data est bien un Blob
				let blob;
				if (response instanceof Blob) {
					blob = response;
				} else {
					// Si ce n'est pas un Blob, le créer
					blob = new Blob([response], {
						type:
							response.headers["content-type"] || "application/octet-stream",
					});
				}
				const downloadUrl = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = downloadUrl;
				link.download = filename;

				// Déclencher le téléchargement
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);

				// Nettoyer l'URL d'objet
				window.URL.revokeObjectURL(downloadUrl);
			},
			(error) => {
				alert("Une erreur est survenu");
			}
		);
	};

	const deleteDoc = async (doc: any) => {
		services.deleteDocument(
			{ id: doc._id },
			async (response, headers) => {
				getDocuments();
			},
			(error) => {
				console.log(error);
				alert("Une erreur est survenu");
			}
		);
	};

	return (
		<div className={`nc-Edit ${className} container`} data-nc-id="Edit">
			<Helmet>
				<title>Utilisateur</title>
			</Helmet>

			<div className="mt-10 flex flex-col sm:w-[70%] justify-center ml-auto mr-auto">
				<Link
					onClick={() => navigate(-1)}
					className="w-10 h-10 sm:w-12 sm:h-12 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full  flex items-center justify-center text-right"
					to={"#"}
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						strokeWidth={1.5}
						stroke="currentColor"
						className="w-6 h-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
						/>
					</svg>
				</Link>
				<div className="space-y-10 sm:space-y-12">
					{/* HEADING */}
					<h2 className="text-2xl sm:text-3xl font-semibold">
						{isEdit && user ? (
							<>
								<div className="text-sm">Utilisateur</div> {user.firstName}{" "}
								{user.lastName}
							</>
						) : (
							"Nouvel utilisateur"
						)}
					</h2>
					{isEdit && user ? (
						<>
							<hr className="mt-3 border-slate-200 dark:border-slate-700 !mt-4 !mb-2"></hr>

							<div className="flex px-2 !my-2">
								{[
									{
										name: "Informations",
										link: "/info",
									},
									{
										name: "Bulletins",
										link: "/bulletins",
									},
								].map((item, index) => (
									<NavLink
										onClick={() => {
											setSelected(item.name);
											// onSelectTab(item.name);
										}}
										key={index}
										to={"#"}
										className={({ isActive }) =>
											`block py-3 px-3 border-b-2 border-transparent flex-shrink-0  text-sm sm:text-base ${
												selected == item.name
													? "border-primary-500 font-medium text-slate-900 dark:text-slate-200"
													: "text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200"
											}`
										}
									>
										{item.name}
									</NavLink>
								))}
							</div>
							<hr className="border-slate-200 dark:border-slate-700 !my-2"></hr>
						</>
					) : null}
					<div className="">
						{selected == "Informations" && (
							<>
								<UserForm user={user} setUser={setUser} errors={errors} />
								<div className="my-5 pt-2 text-center w-full">
									<ButtonPrimary
										onClick={() => saveUser()}
										loading={loading}
										disabled={loading}
										className=" w-full"
									>
										Valider
									</ButtonPrimary>
								</div>
							</>
						)}

						{selected == "Bulletins" && (
							<>
								{documentList.map((doc: any, index: number) => {
									const docDate = dayjs()
										.set("year", doc.documentYear)
										.set("month", doc.documentMonth);
									return (
										<div key={index}>
											{index > 0 && (
												<hr className="mt-3 border-slate-200 dark:border-slate-700 "></hr>
											)}
											<div
												className={`relative flex flex-row items-center justify-between pt-3 sm:pt-3 last:pb-0 first:pt-0 w-[100%] `}
											>
												<div className={`flex-1`}>
													Bulletin{" "}
													<span className="capitalize">
														{docDate.format("MMMM YYYY")}
													</span>
												</div>
												<div className="flex-1 flex justify-end gap-2 ">
													<ButtonPrimary
														onClick={() => download(doc)}
														loading={loading}
														disabled={loading}
														sizeClass="py-2 px-4"
														className="py-2 w-[50%]"
													>
														Télécharger
													</ButtonPrimary>
													<ButtonPrimary
														onClick={() => deleteDoc(doc)}
														loading={loading}
														disabled={loading}
														sizeClass="py-2 px-4"
														className="py-2 !text-red-400 !bg-red-100 border border-red-300 hover:!bg-red-200"
													>
														<TrashIcon className="w-5 h-5" />
													</ButtonPrimary>
												</div>
											</div>
										</div>
									);
								})}
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default UserEdit;
